<template>
  <div>
    <b-card>
      <b-card-header>
        <h2>
          <feather-icon icon="LayersIcon" />
          {{ $t("AppHelpDesk.editIncident") }}
        </h2>
      </b-card-header>
      <b-card-body>
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <b-form
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <b-row>
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="Titulo"
                  rules="required|max:266"
                >
                  <b-form-group
                    :label="$t('AppHelpDesk.titleError')"
                    label-for="titulo"
                  >
                    <b-form-input
                      id="titulo"
                      v-model="incidentData.titulo"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('AppHelpDesk.problemDescription')"
                  rules="required|max:1025"
                >
                  <b-form-group
                    :label="$t('AppHelpDesk.problemDescription')"
                    label-for="description"
                  >
                    <b-form-textarea
                      id="description"
                      v-model="incidentData.descripcion"
                      rows="3"
                      placeholder="Error en la Base de datos principal"
                      :disabled="!$can('write', 'MesaAyuda')"
                    />
                    <b-form-invalid-feedback
                      :state="errors.length > 0 ? false : null"
                    >
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col>
                <b-form-checkbox
                  id="close"
                  v-model="closeIncident"
                  :value="true"
                  :unchecked-value="false"
                >
                  {{ $t("AppHelpDesk.close") }}
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="float-right mt-2 mb-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                <b-spinner
                  v-if="addingIncident"
                  small
                  class="mr-1"
                />
                {{ $t("Lists.Edit") }}
              </b-button>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {
  VBTooltip,
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BFormCheckbox,
  BFormInvalidFeedback,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  required,
  max,
} from '@validations'
import Ripple from 'vue-ripple-directive'
import formValidation from '@core/comp-functions/forms/form-validation'
import helpDeskService from '@/services/helpDesk.service'
import { ref, onMounted } from '@vue/composition-api'
import router from '@/router'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BButton,
    BSpinner,
    BFormGroup,
    BFormCheckbox,
    BFormInvalidFeedback,

    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      required,
      max,
    }
  },
  setup() {
    const addingIncident = ref(false)
    const closeIncident = ref(false)
    const blankIncident = {
      incidenciaId: 0,
      titulo: '',
      descripcion: '',
      fechaInicio: '',
      fechaFin: '',
    }
    const incidentData = ref(JSON.parse(JSON.stringify(blankIncident)))
    const resetIncidentData = () => {
      incidentData.value = JSON.parse(JSON.stringify(blankIncident))
    }
    const {
      refFormObserver,
      resetForm,
      getValidationState,
    } = formValidation(resetIncidentData)

    const {
      fetchIncident,
      updateIncident,
    } = helpDeskService()
    onMounted(() => {
      fetchIncident(router.currentRoute.params.incidenciaId, data => {
        incidentData.value = data
      })
    })
    const onSubmit = () => {
      addingIncident.value = true
      if (closeIncident.value) {
        const date = new Date()
        incidentData.value.fechaFin = date.toLocaleDateString('en-US')
      }
      updateIncident(incidentData.value)
        .then(() => {
          addingIncident.value = false
          router.push({ name: 'apps-tickets-incidents-list' })
        })
        .catch(() => {
          addingIncident.value = false
        })
    }
    return {
      resetIncidentData,
      onSubmit,

      addingIncident,
      incidentData,
      refFormObserver,
      resetForm,
      getValidationState,
      closeIncident,
    }
  },
}
</script>
